export const OPEN_SETTINGS_EVENT = 'gyro:open-settings';
export const OPEN_SETTINGS_REQUEST_EVENT = 'gyro:open-settings-request';
/** The sections a host may open directly: the two the menu offers, Gyro's outfits and General. */
const HOST_SECTIONS = new Set(['look', 'general']);
/** The section a host's request names, or null for anything that is not one it may open. */
export function parseHostSettingsRequest(detail) {
    if (!detail || typeof detail !== 'object' || Array.isArray(detail))
        return null;
    const section = detail.section;
    return typeof section === 'string' && HOST_SECTIONS.has(section) ? section : null;
}
//# sourceMappingURL=hostSettingsRequest.js.map